var map = {
	"./Uptick_IRIS3o.png": "a749",
	"./arrows.png": "b0da",
	"./ban.png": "be60",
	"./bg_b.png": "b175",
	"./btn_close.png": "b8c0",
	"./btn_close1.png": "242e",
	"./btn_menu.png": "d568",
	"./btn_message.png": "a0b9",
	"./btn_message_w.png": "8562",
	"./btn_play1.png": "c8f9",
	"./btn_send.png": "04b9",
	"./burn.png": "1b2b",
	"./cc-zero.png": "23a8",
	"./chain_atom.png": "8a34",
	"./chain_atom_w.png": "2d4b",
	"./chain_dark_uptick.png": "4282",
	"./chain_iris.png": "3ef7",
	"./chain_iris_w.png": "477e",
	"./chain_uptick.png": "9fe3",
	"./chain_usdc.png": "e45b",
	"./chain_usdc_w.png": "3962",
	"./create_collection.png": "ef46",
	"./create_folder.png": "d0c9",
	"./eye.png": "221e",
	"./eye1.png": "9dc9",
	"./eye1_w.png": "eed6",
	"./eye_w.png": "d4ed",
	"./folder_remove.png": "19eb",
	"./icon-calendar.png": "9c5f",
	"./icon-clock.png": "2ff9",
	"./icon1.png": "6c88",
	"./icon2.png": "355a",
	"./icon_IPFS.png": "658e",
	"./icon_IRISHUB.png": "28fd",
	"./icon_Instagram.png": "4ceb",
	"./icon_bd.png": "158c",
	"./icon_build.png": "d3eb",
	"./icon_burn.png": "0182",
	"./icon_cj_collection.png": "17c4",
	"./icon_cj_collection_g.png": "a105",
	"./icon_cj_folder.png": "c4de",
	"./icon_cj_folder_g.png": "5e9f",
	"./icon_cj_nft.png": "369b",
	"./icon_cj_nft_g.png": "c6ff",
	"./icon_claimhistory.png": "df04",
	"./icon_code.png": "1db0",
	"./icon_collection.png": "6907",
	"./icon_collections.png": "5b9c",
	"./icon_collections1.png": "ed66",
	"./icon_complaint.png": "cc54",
	"./icon_complaint_w.png": "ec49",
	"./icon_contract_v.png": "f0c1",
	"./icon_contract_v1.png": "a70c",
	"./icon_copy.png": "48f4",
	"./icon_creation.png": "4ee0",
	"./icon_creation1.png": "d3ff",
	"./icon_cross.png": "ba30",
	"./icon_d.png": "ea4e",
	"./icon_data.png": "c016",
	"./icon_data_w.png": "2d1a",
	"./icon_dbz.png": "05fd",
	"./icon_delete.png": "6aee",
	"./icon_delete1.png": "d6ee",
	"./icon_discord.png": "424e",
	"./icon_download.png": "33d7",
	"./icon_dx_n.png": "c47b",
	"./icon_dx_y.png": "6575",
	"./icon_edit.png": "78af",
	"./icon_edit_w.png": "b686",
	"./icon_email.png": "1de8",
	"./icon_email_foot.png": "6c56",
	"./icon_favorite.png": "e0d3",
	"./icon_favorite1.png": "9eba",
	"./icon_filters.png": "224e",
	"./icon_folder.png": "67ac",
	"./icon_googleplay.png": "454c",
	"./icon_iOS.png": "d730",
	"./icon_jtcross.png": "de51",
	"./icon_l.png": "cc63",
	"./icon_like.png": "acbe",
	"./icon_like1.png": "42c8",
	"./icon_mail.png": "42a5",
	"./icon_medium.png": "611e",
	"./icon_medium_foot.png": "b0fb",
	"./icon_message_all.png": "98ce5",
	"./icon_metadata.png": "9a7a",
	"./icon_onsale.png": "9df5",
	"./icon_pay.png": "94fe",
	"./icon_promo.png": "2e9d",
	"./icon_r.png": "7880",
	"./icon_refresh.png": "b0bd",
	"./icon_rili.png": "083d",
	"./icon_scan.png": "1a3d",
	"./icon_share.png": "e02b",
	"./icon_share_w.png": "1e3b",
	"./icon_site.png": "0f70",
	"./icon_soldout.png": "b187",
	"./icon_tan.png": "6667",
	"./icon_tan_w.png": "a408",
	"./icon_telegram.png": "4842",
	"./icon_telegram_foot.png": "692f",
	"./icon_time.png": "b055",
	"./icon_twitter.png": "f7c8",
	"./icon_twitter_foot.png": "5713",
	"./icon_v.png": "6fd1",
	"./icon_verified.png": "cc3d",
	"./icon_wen.png": "0f26",
	"./icon_yan_yes.png": "4b36",
	"./icon_yes1.png": "fa7b",
	"./icon_youtube.png": "242ee",
	"./icon_z.png": "e9cd",
	"./image_cross.png": "bc21",
	"./image_ooo.png": "a08b",
	"./logo_binance.png": "2859",
	"./logo_keplr.png": "4351",
	"./logo_metamask.png": "c28a",
	"./logo_walletconnect.png": "20d0",
	"./multi_burn.png": "83d5a",
	"./multi_list.png": "f72a",
	"./multi_unlist.png": "3a2e",
	"./officially_verified.png": "0312",
	"./sale_auction.png": "6f55",
	"./sale_auction1.png": "537ca",
	"./sale_discount.png": "69e4",
	"./sale_discount1.png": "9cbe",
	"./sale_execlusive.png": "a229",
	"./sale_execlusive1.png": "fe65",
	"./sale_fixed.png": "0e9b",
	"./search.png": "ccef",
	"./statistical.png": "4b51",
	"./uptick_download.png": "6153",
	"./uptick_logo.png": "eadc",
	"./upward_download.png": "81cb",
	"./view_b.png": "2c01",
	"./view_b1.png": "d448",
	"./view_s.png": "8ae0",
	"./view_s1.png": "b47e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";